import React, { useEffect } from 'react'
import Navbar from './components/Navbar'
import Hero from './components/Hero'
import Footer from './components/Footer'

function App() {
  useEffect(() => {
    // Ensure page starts at top
    window.scrollTo(0, 0)
    
    // Set scroll behavior to auto to prevent smooth scrolling conflicts
    document.documentElement.style.scrollBehavior = 'auto'
    
    // Prevent scroll restoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }

    // Handle mobile view - ensure content is visible below fixed navbar
    const handleResize = () => {
      if (window.innerWidth < 1024) { // lg breakpoint
        // Add top padding to account for fixed navbar on mobile
        const hero = document.querySelector('section')
        if (hero) {
          const navbarHeight = 57.6 // 3.6rem in pixels (h-14.4)
          hero.style.paddingTop = `${navbarHeight}px`
        }
      }
    }

    // Initial check
    handleResize()
    
    // Add resize listener
    window.addEventListener('resize', handleResize)
    
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <div className="flex flex-col h-screen">
      <Navbar />
      <div className="flex-1">
        <Hero />
      </div>
      <Footer />
    </div>
  )
}

export default App